<template>
  <b-row>
    <b-col
      class="text-muted"
      :cols="3">
      Delivery Options
    </b-col>
    <b-col>
      <span v-if="listing.deliverySellerDeliver">
        Seller can deliver
        <font-awesome-icon
          class="mx-1"
          :icon="['far', 'check-circle']"/>
      </span>
      <span v-else>
        <del>
          Seller can deliver
        </del>
      </span>
      <br>
      <span v-if="listing.deliveryMeetMiddle">
        Meet in the middle
        <font-awesome-icon
          class="mx-1"
          :icon="['far', 'check-circle']"/>
      </span>
      <span v-else>
        <del>
          Meet in the middle
        </del>
      </span>
      <br>
      <span v-if="listing.deliveryBuyerPickUp">
        Buyer can pick up
        <font-awesome-icon
          class="mx-1"
          :icon="['far', 'check-circle']"/>
      </span>
      <span v-else>
        <del>
          Buyer can pick up
        </del>
      </span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ListingDeliverySummary',
  props: ['listing'],
}
</script>
